import { getHideDiscountHBX } from "app/reducers/brandSelector";
import { getStore } from "app/configureStore";

// Returns per-guest discount (adults + children) for the visible board of the visible item.
// Returns per-guest discount (adults + children) for the visible board of the visible item.
export const getBoardsDiscountValue = accommodation => {
	if (!accommodation) {
		return 0;
	}
	const visibleAccommodationDescription = accommodation?.accommodationItemDescriptions?.find(
		description => description.label === accommodation?.accommodationLabel
	);
	const visibleAccommodationItem = accommodation?.accommodationItems?.find(item =>
		item?.items?.some(
			inner =>
				inner?.accommodationItemCode ===
				visibleAccommodationDescription?.accommodationItemCode
		)
	);
	const boardsOfItem = visibleAccommodationItem?.boards || [];
	const firstBoard = boardsOfItem[0];
	const visibleBoardCode = accommodation?.boardCode || firstBoard?.boardCode || firstBoard?.code;
	const visibleBoardTypeCode = firstBoard?.boardTypeCode;
	const visibleItemBoard = boardsOfItem.find(
		board =>
			(visibleBoardCode &&
				(board?.boardCode === visibleBoardCode || board?.code === visibleBoardCode)) ||
			(visibleBoardTypeCode && board?.boardTypeCode === visibleBoardTypeCode)
	);
	const discountValue = Number(visibleItemBoard?.discount) || 0;
	if (discountValue <= 0) {
		return 0;
	}
	// Only count paying guests
	const totalGuests = (visibleAccommodationItem?.items || []).reduce((total, item) => {
		return total + (Number(item?.adults) || 0) + (Number(item?.children) || 0);
	}, 0);
	if (totalGuests <= 0) {
		return 0;
	}
	return Math.floor(discountValue / totalGuests);
};

// Returns the discount percentage based on the total displayed price.
export const getBoardsDiscountPercentage = (
	accommodation,
	discountValue = getBoardsDiscountValue(accommodation)
) => {
	const totalPrice = Number(accommodation?.total) || 0;
	if (totalPrice <= 0 || discountValue <= 0) {
		return 0;
	}
	// Formula: ((publicPrice - totalPrice) / publicPrice) * 100, with publicPrice = totalPrice + discountValue.
	const publicPrice = totalPrice + discountValue;
	return Math.floor((discountValue / publicPrice) * 100);
};

// Combines discount value + brand flag to know if the badge must be visible.
export const getDiscountBadgeVisibility = (accommodation, state = getStore()?.getState()) => {
	if (!state || !accommodation) {
		return false;
	}
	const discountValue = getBoardsDiscountValue(accommodation);
	const hideDiscountHBX = getHideDiscountHBX(state);

	return !hideDiscountHBX && discountValue > 0;
};
